import React from "react";
import { Button, createTheme, InputLabel, MenuItem, Select, SelectChangeEvent, ThemeProvider, TextField } from "@mui/material";
import { ExpressionType } from "../Shared/Party/PartyConfigData";
//import { HighlightOff, ChatBubble } from "@mui/icons-material";

//import { PurchaseBoosts } from "./PurchaseBoosts";
//import { StateManagerContext } from "./StateManagerContext";
import { UIConfigContext } from "./UIConfigContext";

export const BoostLevels: { label: string, boosts: number }[] = [
  { label: 'No Boost', boosts: 0 },
  { label: '1,000 Impression Boosts', boosts: 1000 },
  { label: '2,500 Impression Boosts', boosts: 2500 },
  { label: '5,000 Impression Boosts', boosts: 5000 },
  { label: '10,000 Impression Boosts', boosts: 10000 },
  { label: '25,000 Impression Boosts', boosts: 25000 },
];




const expressionText = [
  "inspire",
  "appreciate",
  "critique",
  "observe",
  "inform",
  "banter/joke",
];

export type ReplyPanelProps = {
  replyCallback: (expression: ExpressionType, message: string, boosts: number) => void;
  cancelCallback: () => void;
  height: number;
};




type ReplyPanelState = 'draft' | 'confirm';


export const ReplyPanel = ({
  replyCallback,
  cancelCallback,
  height,
}: ReplyPanelProps) => {

  //const stateManager = React.useContext(StateManagerContext);
  const uiConfig = React.useContext(UIConfigContext);
  //const boosts = stateManager.user().accountInformation.boostBalance;



  const expressionLabelText = 'Choose Your Message Purpose';

  //const selectedExpression = React.useRef<ExpressionType>("undefined");
  const [expressionSelectData, setExpressionSelectData] = React.useState<string>(expressionLabelText);
  //const [boostSelect, setBoostSelect] = React.useState<number>(BoostLevels[0].boosts);
  //const [boostPackage, setBoostPackage] = React.useState<string>('');
  //const [authorizedPayment, setAuthorizedPayment] = React.useState<boolean>(false);
  //const [clientSecret, setClientSecret] = React.useState<string>('');

  /*const _setBoostSelect = (value: string) => {
    BoostLevels.forEach((row) => {
      if (value === row.label)
        setBoostSelect(row.boosts);
    })
  }*/




  //const [panelState, setPanelState] = React.useState<ReplyPanelState>('draft');
  //const textFieldContents = React.useRef("");

  const [replyText, setReplyText] = React.useState<string>("");

  let isExpressionSelected = expressionSelectData !== expressionLabelText;
  const isEnoughText = replyText.length > 10;


  //const enoughBoosts = boostSelect <= boosts;
  //const boostNeed = boosts - boostSelect;

  const sendHandler = () => {
   // if (enoughBoosts) {
      const expression: ExpressionType = expressionSelectData === '0' ? "inspiring" : (expressionSelectData === '1' ? "appreciative" : (expressionSelectData === '2' ? "smart" : (expressionSelectData === '3' ? "perceptive" : (expressionSelectData === '4' ? "informative" : "funny"))));
      replyCallback(expression, replyText, 0);// boostSelect);
      setExpressionSelectData(expressionLabelText);
      //setPanelState('draft');
      setReplyText("");
    /*}
    else {
      setPanelState('payment');
    }*/

  }



  /*const closeThankYou = () => {
    const expression: ExpressionType = expressionSelectData === '0' ? "inspiring" : (expressionSelectData === '1' ? "appreciative" : (expressionSelectData === '2' ? "smart" : (expressionSelectData === '3' ? "perceptive" : (expressionSelectData === '4' ? "informative" : "funny"))));
    replyCallback(expression, replyText, 0); //boostSelect);
    setExpressionSelectData(expressionLabelText);
    setReplyText("");
  }*/

  /*const paymentCallback = (purchase : boolean) => {
    setPanelState(purchase ? 'confirm' : 'draft')
  }*/


  const theme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  const pageElements: JSX.Element[] = [];


  //if (panelState === 'draft') {
    /*pageElements.push(<div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', marginTop: '20px', marginBottom: '10px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 1, justifyContent: 'left', marginLeft: '30px' }}>
        <ChatBubble sx={{ width: '18px' }} />
        <span style={{ fontSize: '18px', color: 'white' }}>Add Comment</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 2, justifyContent: 'right', marginRight: '30px' }}>
        <HighlightOff sx={{ height: '36px' }} onClick={() => { cancelCallback(); }} />
      </div>
    </div>);*/
    /*pageElements.push(<InputLabel id='message-boost-select-label'>Select how many boosted impressions you want</InputLabel>);
    pageElements.push(<Select
      labelId="message-boost-select-label"
      id="message-boost-select"
      label="Boost Level"
      onChange={(ev: SelectChangeEvent) => { _setBoostSelect(ev.target.value) }}
      sx={{
        color: 'white',
        backgroundColor: '#303030',
        fontSize: uiConfig.fontBase,
        borderRadius: '8px',
        marginTop: '10px',
        marginLeft: '30px',
        marginRight: '30px',
        marginBottom: '10px',
      }}
    >
      {BoostLevels.map((row, index) => {
        if(row.boosts <= boosts )
        return <MenuItem value={row.label} key={'ReplyPanel_BoostSelect_' + index}>{row.label}</MenuItem>
      })}

    </Select>);*/
    /*if (!enoughBoosts)
      pageElements.push(<span style={{ fontSize: '14px', fontWeight: 400, marginTop: '10px', marginBottom: '10px', marginLeft: '30px', marginRight: '30px', color: '#e6007e' }}>
        You will need to purchase boosts. You will be able to do this after clicking send.
      </span>);*/
    pageElements.push(<InputLabel id='message-expression-select-label'>Choose your comment purpose</InputLabel>);
    pageElements.push(<Select
      labelId="message-expression-select-label"
      id="message-expression-select"
      value={expressionSelectData}
      label="Message Type"
      onChange={(ev: SelectChangeEvent) => { setExpressionSelectData(ev.target.value) }}
      sx={{
        color: 'white',
        backgroundColor: '#303030',
        fontSize: uiConfig.fontBase,
        borderRadius: '8px',
        marginTop: '10px',
        marginLeft: '30px',
        marginRight: '30px',
        marginBottom: '10px',
      }}
    >
      <MenuItem value={'0'}>{expressionText[0]}</MenuItem>
      <MenuItem value={'1'}>{expressionText[1]}</MenuItem>
      <MenuItem value={'2'}>{expressionText[2]}</MenuItem>
      <MenuItem value={'3'}>{expressionText[3]}</MenuItem>
      <MenuItem value={'4'}>{expressionText[4]}</MenuItem>
      <MenuItem value={'5'}>{expressionText[5]}</MenuItem>

    </Select>);
    pageElements.push(<TextField onChange={(ev) => { setReplyText(ev.target.value); }} value={replyText} autoFocus={true} sx={{
      backgroundColor: '#303030',
      color: 'white',
      borderRadius: '8px',
      marginTop: '10px',
      marginLeft: '30px',
      marginRight: '30px',
      marginBottom: '10px',
    }} label='Your Message' />);
    pageElements.push(<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', marginRight: '30px' }}>
      {(isEnoughText && isExpressionSelected) && (<Button onClick={() => { sendHandler(); }}
        sx={{
          borderRadius: '25px',
          width: '92px',
          minWidth: '92px',
          maxWidth: '92px',
          height: '48px',
          minHeight: '48px',
          maxHeight: '48px',
          color: 'black',
          fontSize: '18px',
          fontWeight: 400,
          backgroundColor: '#92CA36'
        }} >Post</Button>)}
      {(!(isEnoughText && isExpressionSelected)) && (<Button disabled
        sx={{
          borderRadius: '25px',
          width: '92px',
          minWidth: '92px',
          maxWidth: '92px',
          height: '48px',
          minHeight: '48px',
          maxHeight: '48px',
          fontSize: '18px',
          fontWeight: 400,
          color: 'white',
          backgroundColor: '#303030'
        }} >Post</Button>)}
    </div>);
  //}
  /*else if (panelState === 'payment') {
    pageElements.push(<PurchaseBoosts  height={height}  boostNeed={boostNeed} callback={paymentCallback}/> );
  }*/
  /*else {
    pageElements.push(<div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', marginTop: '20px', marginBottom: '10px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 1, justifyContent: 'left', marginLeft: '30px' }}>
         
        <span style={{ fontSize: '18px', color: 'white' }}>Thank you</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 2, justifyContent: 'right', marginRight: '30px' }}>
        <HighlightOff sx={{ height: '36px' }} onClick={() => { closeThankYou(); }} />
      </div>
    </div>);
    pageElements.push(<span style={{ fontSize: '16px', color: 'white' }}>
      {'Thank you, your payment was successfully processed and your post is being boosted by ' + boostSelect + ' impressions'}
    </span>);

    //<ChatBubble sx={{ width: '18px', opacity: authorizedPayment ? 1 : 0 }} />

  }*/

  return (
    <div style={{
      width: uiConfig.width + 'px',
      minWidth: uiConfig.width + 'px',
      maxWidth: uiConfig.width + 'px',
      height: height + 'px',
      minHeight: height + 'px',
      maxHeight: height + 'px',
      backgroundColor: uiConfig.contolBackground,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative'
    }}>
      <script async src='https://js.stripe.com/v3/' onLoad={() => { }} />
      <ThemeProvider theme={theme}>
        {pageElements}
      </ThemeProvider>
    </div>
  );

};
